import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import Name from '@/components/Name'
import { Column, NameCell } from '@/components/BsrsGrid'

export default ({ nameProp = 'name', latinNameProp = 'latinName', locale, ...props }) => {
  return <Column
    field={locale === 'ar' ? nameProp : latinNameProp}
    cell={NameCell({ locale, nameProp, latinNameProp })}
    {...props} />
}

export const LookupNameColumn = ({ field, locale, ...props }) => {
  class LookupNameCell extends GridCell {
    render () {
      let value = this.props.dataItem[field]
      return (<td><Name data={value} /></td>)
    }
  }

  const exportCell = ({ dataItem }) => {
    const nameSelector = locale === 'en' ? 'latinName' : 'name'
    return dataItem[field][nameSelector]
  }

  return <Column
    field={locale === 'ar' ? `${field}Name` : `${field}LatinName`}
    cell={LookupNameCell}
    cellExport={exportCell}
    {...props} />
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.NameColumn.js